// src/colors/monochromaticPalettes.js
const monochromaticPalettes = [
  { name: 'Ocean Blue', colors: ['#4a90e2', '#87bfff', '#bddaff', '#e5f2ff', '#001f3f'] },
  { name: 'Forest Green', colors: ['#2d5a27', '#4a8f43', '#7bc474', '#c2e6be', '#193d16'] },
  { name: 'Royal Purple', colors: ['#9C27B0', '#BA68C8', '#CE93D8', '#E1BEE7', '#4A1452'] },
  { name: 'Ruby Red', colors: ['#FF0A54', '#FF477E', '#FF7096', '#FF99AC', '#CC0843'] },
  { name: 'Emerald', colors: ['#004B49', '#006C67', '#00938F', '#00BAB7', '#002928'] },
  { name: 'Amethyst', colors: ['#663399', '#8047B3', '#9966CC', '#B285E6', '#331A4D'] },
  { name: 'Sapphire', colors: ['#0F52BA', '#3B7BE4', '#67A4FF', '#93CDFF', '#072B61'] },
  { name: 'Crimson', colors: ['#DC143C', '#E44D6C', '#EC869C', '#F4BFCC', '#8A0C25'] },
  { name: 'Golden Yellow', colors: ['#FFD700', '#FFDF00', '#FFF200', '#FFEB00', '#B8860B'] },
  { name: 'Slate Gray', colors: ['#708090', '#778899', '#839496', '#94A3B4', '#2F4F4F'] },
  { name: 'Burnt Orange', colors: ['#CC5500', '#D2691E', '#E97451', '#FF7F50', '#8B3A3A'] },
  { name: 'Blush Pink', colors: ['#FFB6C1', '#FFA6B9', '#FF96B1', '#FF8699', '#FF7691'] },
  { name: 'Graphite Gray', colors: ['#2C2C2C', '#3D3D3D', '#555555', '#777777', '#999999'] },
  { name: 'Lime Green', colors: ['#E8F5E9', '#C8E6C9', '#A5D6A7', '#81C784', '#66BB6A'] },
  { name: 'Lavender', colors: ['#F3E5F5', '#E1BEE7', '#CE93D8', '#BA68C8', '#AB47BC'] },
  { name: 'Coral', colors: ['#FF7F50', '#FF8F60', '#FFA07A', '#FFB08A', '#FFC0A0'] },
  { name: 'Burnt Sienna', colors: ['#E97451', '#D87F4D', '#C98947', '#B99442', '#A99F3C'] },
  { name: 'Deep Olive', colors: ['#556B2F', '#6B8E23', '#7C9D32', '#8DAB41', '#9EB650'] },
  { name: 'Sky Blue', colors: ['#87CEEB', '#7EC0EE', '#76AEE2', '#6E9BD6', '#6689CA'] },
  { name: 'Turquoise', colors: ['#40E0D0', '#3AC7C1', '#34AEB3', '#2E95A5', '#288C97'] },
  { name: 'Plum', colors: ['#8E4585', '#9D5494', '#AD63A3', '#BD72B2', '#CC81C1'] },
  { name: 'Chocolate', colors: ['#3E2723', '#4E342E', '#5D4037', '#6D4C41', '#795548'] },
  { name: 'Silver', colors: ['#C0C0C0', '#D3D3D3', '#E0E0E0', '#EDEDED', '#F5F5F5'] },
  { name: 'Indigo', colors: ['#3F51B5', '#5C6BC0', '#7986CB', '#9FA8DA', '#C5CAE9'] },
  { name: 'Peach', colors: ['#FFE5B4', '#FFD8A8', '#FFCC9C', '#FFBF90', '#FFB384'] },
  { name: 'Copper', colors: ['#B87333', '#C17E3A', '#CD7F32', '#D2691E', '#DC7633'] },
  { name: 'Periwinkle', colors: ['#CCCCFF', '#B3B3FF', '#9999FF', '#8080FF', '#6666FF'] },
  { name: 'Magenta', colors: ['#FF00FF', '#EE00EE', '#DD00DD', '#CC00CC', '#BB00BB'] },
  { name: 'Aqua', colors: ['#00FFFF', '#00E5EE', '#00CCCC', '#00B2B2', '#009999'] },
  { name: 'Lime', colors: ['#CCFF90', '#B2FF59', '#9EEA4A', '#8BE341', '#77D334'] },
  { name: 'Wine', colors: ['#722F37', '#833442', '#94404D', '#A35059', '#B66064'] },
  { name: 'Midnight Black', colors: ['#0D0D0D', '#1A1A1A', '#262626', '#333333', '#404040'] }
];

export default monochromaticPalettes;
